import { JobType, Task } from '../../../../../../clients/quipli-service/job-tasks/job-tasks';
import { OrderProduct } from '../../../../../../clients/quipli-service/order/order';
import { Typography } from '../../../../../../components/typography/typography';

/**
 * Hours and fuel section (to display on the order page)
 * @param hoursTask - The hours task.
 * @param jobType - The job type.
 * @param orderProduct - The order product.
 * @param fuelUnit - The fuel unit to display.
 */
export const HoursFuelSection = ({
  hoursTask,
  jobType,
  orderProduct,
  fuelUnit,
}: {
  hoursTask: Task;
  jobType: JobType;
  orderProduct: OrderProduct;
  fuelUnit: 'gallons' | 'liters';
}) => {
  return (
    <div className="divider-top">
      <p className="text-sm font-semibold mb-2">{hoursTask.header}</p>
      {orderProduct.product.allowHourTracking && (
        <div className="flex justify-between mb-2">
          <Typography type="text-sm">
            Machine hours at {jobType === JobType.CheckoutInspection ? 'check out' : 'check in'}
          </Typography>
          <Typography type="text-sm">
            {hoursTask.metadata?.hours ? `${hoursTask.metadata.hours} hours` : 'Pending'}
          </Typography>
        </div>
      )}
      {jobType === JobType.CheckinInspection && orderProduct.product.fuelChargeProductId && (
        <div className="flex justify-between mb-2">
          <Typography type="text-sm">Fuel at check in</Typography>
          <Typography type="text-sm">
            {hoursTask.metadata?.fuel ? `${hoursTask.metadata.fuel} ${fuelUnit}` : 'Pending'}
          </Typography>
        </div>
      )}
    </div>
  );
};
